
<template>
    <div id="form-element-textarea-demo">
        <textarea-default></textarea-default>
        <textarea-label></textarea-label>
        <textarea-counter></textarea-counter>
        <textarea-height></textarea-height>
    </div>
</template>

<script>
import TextareaDefault from './TextareaDefault.vue';
import TextareaLabel from './TextareaLabel.vue';
import TextareaCounter from './TextareaCounter.vue';
import TextareaHeight from './TextareaHeight.vue';

export default{
    components: {
        TextareaDefault,
        TextareaLabel,
        TextareaCounter,
        TextareaHeight,
    },
};
</script>
